<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M17.256 8.678a.84.84 0 0 0-.735-.434h-2.496l3.164-4.959A.84.84 0 0 0 16.48 2H9.995a.823.823 0 0 0-.81.651l-2.162 9.45a.835.835 0 0 0 .81 1.027h1.97l-1.795 7.845A.84.84 0 0 0 8.825 22a.844.844 0 0 0 .701-.384l7.705-12.07a.822.822 0 0 0 .025-.852v-.016Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
